import {
	ADMINCREATECURRENCYMAPPING_SUCCESS,
	ADMINCREATECURRENCYMAPPING_FAILED,
	RESET_ADMINCREATECURRENCYMAPPING,
	LOADING_ADMINCREATECURRENCYMAPPING,
	NETWORK_ERROR_ADMINCREATECURRENCYMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINCREATECURRENCYMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINCREATECURRENCYMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINCREATECURRENCYMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINCREATECURRENCYMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINCREATECURRENCYMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
